import { UserAttributes, getUserAttribute } from "shared-auth";
import profileApi from "./profile-api";

export async function getFilmmakersSSOLink(redirectUrl: string) {
  const profileId = getUserAttribute(UserAttributes.MasterPortalGuid);

  const { data } = await profileApi.profiles.profilesFilmmakersSsoLink<{
    url: string;
  }>(profileId, {
    redirectUrl,
  });

  console.log("data", data);

  return data;
}
